import { SCROLL_CONTAINER_LAYER, SCREEN_LAYER, CURRENT_SCREEN_ID, CURRENT_OVERLAY_ID, OVERLAY_LAYER, } from '../constants/userTest';
import { viewportToImage } from './transformCoordinates';
export function getEventMeta(state, event, _a) {
    var isShowingOverlay = (_a === void 0 ? {} : _a).isShowingOverlay;
    var layerElement = findClosestLayer(event.target);
    var layerType;
    if (isShowingOverlay && layerElement.dataset.layerType === SCREEN_LAYER) {
        // We're off the overlay but convert the coordinates relative to the
        // overlay.
        layerType = OVERLAY_LAYER;
    }
    else {
        (layerType = layerElement.dataset.layerType);
    }
    var layerId = layerElement.dataset.layerId;
    var layer = {
        type: layerType,
        id: Number(layerId),
    };
    return {
        layer: layer,
        // Note we do the coordinate transformation here so we have access to the
        // state _at the time the event was generated_ (this might have been better
        // as middleware rather than using partial in mapStateToProps in severl
        // components?)
        coords: viewportToImage(state, layer, { x: event.pageX, y: event.pageY }),
        // The following are present for touch events only
        duration: event.duration,
        startCoords: event.startCoords && viewportToImage(state, layer, event.startCoords),
        endCoords: event.endCoords && viewportToImage(state, layer, event.endCoords),
    };
}
export function getLayerDOMElement(_a) {
    var layerType = _a.type, id = _a.id;
    if (layerType === SCROLL_CONTAINER_LAYER) {
        return document.querySelector("[data-layer-type=\"" + layerType + "\"][data-layer-id=\"" + id + "\"]");
    }
    // TODO shouldn't be using ids (what if there's more than one instance of the
    // player -- really should be using refs if possible)
    var layerID = layerType === SCREEN_LAYER ? CURRENT_SCREEN_ID : CURRENT_OVERLAY_ID;
    return document.getElementById(layerID);
}
export function findClosestLayer(element, layerType) {
    if (layerType) {
        return element.closest("[data-layer-type=\"" + layerType + "\"]");
    }
    return element.closest('[data-layer-type]');
}
